import * as z from "zod";
import { userFacingError } from "../authorization";
import { mutator } from "./mutator";

export const updateOAuthAppSchema = z.object({
  id: z.string(),
  name: z.string().min(1).max(120).optional(),
  redirectUris: z.array(z.string().min(1).max(2048)).min(1).optional(),
  disabled: z.boolean().optional(),
});

function isValidRedirectUri(uri: string): boolean {
  try {
    return new URL(uri).protocol === "https:";
  } catch {
    return false;
  }
}

export const updateOAuthApp = mutator({
  schema: updateOAuthAppSchema,
  resolve: {
    app: { kind: "oauthClient", from: "id" },
  },
  permissions: [
    {
      permission: "tenant:oauth_apps_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
  ],
  fn: async ({ tx, args: { app, name, redirectUris, disabled } }) => {
    if (redirectUris && !redirectUris.every(isValidRedirectUri)) {
      throw userFacingError("Redirect URIs must be HTTPS URLs");
    }
    const updates: Record<string, unknown> = {
      id: app.id,
      updatedAt: Date.now(),
    };
    if (name !== undefined) updates.name = name;
    if (redirectUris !== undefined) updates.redirectUris = redirectUris;
    if (disabled !== undefined) updates.disabled = disabled;
    await tx.mutate.oauthClient.update(updates as { id: string });
  },
});
